import { roundSwitch, showErrorInfo } from '../../forms/newFields';
import React from 'react';

export function PureBoolField({ label, mandatory, ...props }) {
  return (
    <div className="scope-field-container">
      <div className="scope-boolean-container">
        <span className="scope-boolean-info">
          {label}
          {!!mandatory && ' *'}
        </span>
        {roundSwitch(props)}
      </div>
      {showErrorInfo(props)}
    </div>
  );
}

